import { render, staticRenderFns } from "./RoomMenu.vue?vue&type=template&id=d5d31ef4&scoped=true&"
import script from "./RoomMenu.vue?vue&type=script&lang=js&"
export * from "./RoomMenu.vue?vue&type=script&lang=js&"
import style0 from "./RoomMenu.vue?vue&type=style&index=0&id=d5d31ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d31ef4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5d31ef4')) {
      api.createRecord('d5d31ef4', component.options)
    } else {
      api.reload('d5d31ef4', component.options)
    }
    module.hot.accept("./RoomMenu.vue?vue&type=template&id=d5d31ef4&scoped=true&", function () {
      api.rerender('d5d31ef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Menu/RoomMenu.vue"
export default component.exports